export class GooglePlaceData {
	public populartimes: {
		Monday: number[]
		Tuesday: number[]
		Wednesday: number[]
		Thursday: number[]
		Friday: number[]
		Saturday: number[]
		Sunday: number[]
	}

	constructor(data: {
		populartimes: {
			Monday: number[]
			Tuesday: number[]
			Wednesday: number[]
			Thursday: number[]
			Friday: number[]
			Saturday: number[]
			Sunday: number[]
		}
	}) {
		this.populartimes = data.populartimes
	}

	static create(partial: Partial<GooglePlaceData>): GooglePlaceData {
		const defaultData = {
			populartimes: {
				Monday: [],
				Tuesday: [],
				Wednesday: [],
				Thursday: [],
				Friday: [],
				Saturday: [],
				Sunday: [],
			},
		}
		return new GooglePlaceData({ ...defaultData, ...partial })
	}
}
